"use client";
import { useRef, useEffect, useState } from 'react';
import 'swiper/css'; // core Swiper
import "swiper/css/effect-fade";
import 'swiper/css/pagination'; // Pagination module
import { register } from 'swiper/element/bundle';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import styles from './styles.module.scss';
import Slide from './Slide';
import NavigationBar from './NavigationBar';

const BrandHero = ({ heroSlides }) => {
    const imageSliderRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [animate, setAnimate] = useState(false);
    const [isSwiperReady, setIsSwiperReady] = useState(false);
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" ? window.innerWidth <= 768 : false
    );

    useEffect(() => {
        if(window) {
            const checkIfMobile = () => window.innerWidth <= 768;
            setIsMobile(checkIfMobile());
    
            const handleResize = () => {
                setIsMobile(checkIfMobile());
            };
    
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }

    }, []);

    useEffect(() => {
        register();
    
        const params = {
            modules: [Navigation, Pagination, Autoplay, EffectFade],
            effect: 'fade',
            fadeEffect: { crossFade: true },
            touchEventsTarget: 'container',
            allowTouchMove: isMobile, // Enable touch/swipe only on mobile
            loop: true,
            on: {
                touchEnd: (e) => {
                    const newIndex = e.realIndex;
                    const prevIndex = activeIndex === 0 ? heroSlides.length - 1 : activeIndex - 1;
                    const nextIndex = activeIndex === heroSlides.length - 1 ? 0 : activeIndex + 1;
                    
                    if (newIndex === prevIndex) {
                        setActiveIndex(prevIndex);
                    } else if (newIndex === nextIndex) {
                        setActiveIndex(nextIndex);
                    } else {
                        setActiveIndex(newIndex);
                    }
                    
                    setTimeout(() => setAnimate(false), 500);
                },
                init: () => setIsSwiperReady(true),
                slideChangeTransitionStart: () => setAnimate(true),
                slideChangeTransitionEnd: (e) => {
                    setActiveIndex(e.activeIndex);
                    setTimeout(() => setAnimate(false), 500);
                },
            }
        };
    
        Object.assign(imageSliderRef.current, params);
    
        imageSliderRef.current.initialize();
    }, [isMobile]);

    const handleNavClick = (index) => {
        if (imageSliderRef.current?.swiper) {
            imageSliderRef.current.swiper.slideTo(index);
        }
    };

    const formatClassName = (title) => {
        return title.toLowerCase().replace(/\s+/g, '-').replace(/&/g, '-');
    };

    const renderImageSlides = () => {
        return heroSlides?.map((slide, index) => (
            <swiper-slide key={index} className={formatClassName(slide?.heroSlide?.title || '')}>
                <Slide {...slide?.heroSlide} animate={animate} />
            </swiper-slide>
        ));
    };

    return (
        <section className={`${styles.brandHero} ${animate ? 'animateOn': ''} ${formatClassName(heroSlides?.[activeIndex]?.heroSlide?.title || '')}`}>
            <div className={styles.brandHero__inner}>
                <swiper-container init="false" ref={imageSliderRef}>
                    {renderImageSlides()}
                </swiper-container>
                <NavigationBar slides={heroSlides} activeIndex={activeIndex} onNavClick={handleNavClick} />
            </div>
        </section>
    );
};

export default BrandHero;
